export default "__VITE_ASSET__873a2c35__"